import { formatMoneyAddDecimalPoint } from "./PaymentUtils";
import { isSupplierAccount } from "./AccountUtils";
import { Account } from "../types/Account";

// Extend Window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

interface Booking {
  initialCharge: number;
  orderNumber: string;
  numberOfSpaces: number;
}

export const sendSignUpEvent = (account: Account): void => {
  window.dataLayer = window.dataLayer || [];
  if (isSupplierAccount(account)) {
    window.dataLayer.push({
      event: 'partnerSignUp'
    });
  } else {
    window.dataLayer.push({
      event: 'customerSignUp'
    });
  }
}

export const sendPurchaseEvent = (booking: Booking): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'bookingPurchase',
    purchase: {
      value: formatMoneyAddDecimalPoint(booking.initialCharge),
      transaction_id: booking.orderNumber,
      number_of_spaces: booking.numberOfSpaces,
    }
  });
}
